import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FascicoloFull } from 'src/app/common/models/fascicolo/fascicolo-full';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { HelpersService } from "../../../../core/services/helpers.service";
import { OperationsService } from "../../../../core/services/operations.service";
import { Controparte } from "../../../models/controparte";
import { SezioneContropartiResponse } from "../../../models/dto/sezione-controparti-response";
import { Patologia } from "../../../models/patologia";
import { SezionePatologie } from "../../../models/sezioni/sezione-patologie";
import { FormValidationService } from "../../../services/form-validation.service";

declare var closeModal: any;
declare var openModal: any;
declare var $: any;

@Component({
    selector: 'div [patologie-mod-add]',
  templateUrl: 'patologie-mod-aggiungi.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class PatologieModAggiungi {
  pathPatologieUrl: string;
  urlReadSezioneControparti: string;
  idSezione: string;
  idFascicolo: string;
  idParent: string;
  idPratica: string;
  patologiaForm: FormGroup;
  request: Patologia;
  fascicolo: FascicoloFull;
  PROPERTIES_SETTINGS = PropertiesSettings;

  msgNoBeneficiari: string;

  edit: boolean;
  inserimento: boolean;
  contropartiAll: Controparte[]=[];
  today:number;

  visibleToggleAssocia: boolean = false;
  visibleToggleForm: boolean = false;

  constructor(protected operationService: OperationsService,
              private campiForm: FormBuilder,
              private helpers: HelpersService,
              private formValidationService: FormValidationService) {}

  @Input() controparte: Controparte;
  @Output() onReturn: EventEmitter<SezionePatologie> = new EventEmitter<SezionePatologie>();

  inizializza(pathPatologieUrl, idPratica, urlReadSezioneControparti, idSezione, fascicolo, idParent, edit = false) {
    this.pathPatologieUrl = pathPatologieUrl;
    this.urlReadSezioneControparti = urlReadSezioneControparti;
    this.idSezione = idSezione;
    this.idFascicolo = fascicolo.id;
    this.fascicolo = fascicolo;
    this.idParent = idParent;
    this.idPratica = idPratica;
    this.edit = edit;
    this.inserimento = !edit;
    this.today=new Date().getTime();
    this.readSezioneControparti(urlReadSezioneControparti);
    this.initViewToggle();
    openModal('modalmodaggiungipatologia');
  }

  createForm(request = new Patologia()) {
    this.request = request;

    this.patologiaForm = this.campiForm.group({
      patologia: [this.request.patologia, Validators.required],
      dataDiagnosi: [this.request.dataDiagnosi, Validators.required],
      dataDecesso: [this.request.dataDecesso],
      riconoscimentoMalattiaProfessionale: [this.request.riconoscimentoMalattiaProfessionale, Validators.required],
      dataRiconoscimento: [this.request.dataRiconoscimento],
      percentualeInvalidita: [this.request.percentualeInvalidita],
      note: [this.request.note],
    });

  }

  initViewToggle() {
    this.visibleToggleAssocia = false;
    this.visibleToggleForm = true;
    if (this.inserimento) {
      this.visibleToggleAssocia = true;
      this.visibleToggleForm = false;
    }
  }

  readSezioneControparti(url){
    this.operationService.readSezione(url, this.fascicolo.idSezioneControparti).subscribe(response=>{
      this.readContropartiResponse(response);
    })
  }

  readContropartiResponse(response: SezioneContropartiResponse){
    this.contropartiAll = (<SezioneContropartiResponse>response).sezione.controparti;
    this.msgNoBeneficiari = 'Non esistono controparti da associare.'
  }
  changeRiconoscimentoMalattiaProfessionale(value) {
    if (value) {
      this.patologiaForm.controls['dataRiconoscimento'].setValidators([Validators.required]);
    } else {
      this.request.dataRiconoscimento = null;
      this.patologiaForm.controls['dataRiconoscimento'].clearValidators();
    }
    this.patologiaForm.controls['dataRiconoscimento'].updateValueAndValidity();
  }

  associaControparte(obj: Controparte) {
    this.createForm();
    this.controparte = this.contropartiAll.filter(controparte => { return controparte.id === obj.id; })[0];
    this.visibleToggleAssocia = false;
    this.visibleToggleForm = true;
  }

  /*manageModal(sezione: SezionePatologie) {
      this.createForm();
      closeModal('modalmodaggiungipatologia');
      this.onReturn.emit(sezione);
  }*/

  update() {
    console.log(this.request);
    if (this.edit) {
      this.operationService.updatePatologia(this.request, this.pathPatologieUrl, this.idSezione, this.idFascicolo).subscribe(
        response => {
          this.onReturn.emit(<SezionePatologie> response);
          closeModal('modalmodaggiungipatologia');
        });
    } else {
      const requestPatologia = {
        ...this.request,
        lavoratore: this.controparte.parte
      };
      this.operationService.addPatologia(requestPatologia, this.pathPatologieUrl, this.idSezione, this.idFascicolo).subscribe(
        response => {
          this.onReturn.emit(<SezionePatologie> response);
          closeModal('modalmodaggiungipatologia');
        });
    }
  }
}
